import { render, staticRenderFns } from "./avis-medicaux-recus.html?vue&type=template&id=fbc7c2de&external"
import script from "./avis-medicaux-recus.js?vue&type=script&lang=js&external"
export * from "./avis-medicaux-recus.js?vue&type=script&lang=js&external"
import style0 from "./avis-medicaux-recus.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports